export const buttonScaleHover = 'transform hover:scale-105 hover:transition-transform hover:duration-75';
export const buttonScaleHoverY = 'transform hover:scale-y-105 hover:transition-transform hover:duration-75';